<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="small text-muted mb-0">filter_display</span>
      <b-button size="sm" variant="outline-primary" @click="addRow">+ Row</b-button>
    </div>

    <b-table
      small
      bordered
      head-variant="light"
      :items="tableItems"
      :fields="tableFields"
      responsive="sm"
      class="mb-2 filter-display-table"
    >
      <template #cell(field)="{ item }">
        <span class="small text-muted">{{ item.field }}</span>
      </template>

      <template #cell(value)="{ item }">
        <b-form-input
          v-if="item.key === 'column'"
          v-model="safeRows[item.rowIndex].column"
          size="sm"
        />
        <b-form-input
          v-else-if="item.key === 'label'"
          v-model="safeRows[item.rowIndex].label"
          size="sm"
        />
        <b-form-input
          v-else-if="item.key === 'default'"
          size="sm"
          :value="defaultValueStr(safeRows[item.rowIndex])"
          @input="setDefaultFromStr(safeRows[item.rowIndex], $event)"
        />
      </template>

      <template #cell(actions)="{ item }">
        <b-button
          v-if="item.key === 'column'"
          size="sm"
          variant="outline-danger"
          @click="removeRow(item.rowIndex)"
        >
          Remove
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ScreenConfigFilterDisplayEditor",
  props: {
    value: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
  },
  data() {
    return {
      tableFields: [
        { key: "field", label: "Field" },
        { key: "value", label: "Value" },
        { key: "actions", label: "", class: "text-right", thStyle: { width: "70px" } },
      ],
    };
  },
  computed: {
    safeRows() {
      return Array.isArray(this.value) ? this.value : [];
    },
    tableItems() {
      const rows = this.safeRows || [];
      const items = [];
      rows.forEach((row, ri) => {
        items.push({
          _id: `c-${ri}`,
          rowIndex: ri,
          field: "Column",
          key: "column",
        });
        items.push({
          _id: `l-${ri}`,
          rowIndex: ri,
          field: "Label",
          key: "label",
        });
        items.push({
          _id: `d-${ri}`,
          rowIndex: ri,
          field: "Default value (comma-separated)",
          key: "default",
        });
      });
      return items;
    },
  },
  methods: {
    addRow() {
      const next = [...this.safeRows];
      next.push({
        column: "",
        label: "",
        default_value: [],
      });
      this.$emit("input", next);
    },
    removeRow(i) {
      const next = [...this.safeRows];
      next.splice(i, 1);
      this.$emit("input", next);
    },
    defaultValueStr(row) {
      const v = row.default_value;
      if (v == null) return "";
      if (Array.isArray(v)) return v.join(", ");
      return String(v);
    },
    setDefaultFromStr(row, s) {
      const parts = String(s || "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean);
      this.$set(row, "default_value", parts);
    },
  },
};
</script>
